import React from 'react'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'
import { Input } from 'components/UIElements';
import PatternInput from './PatternInput'
import { PRE_SCREEN_ID_PLACEHOLDER } from 'utils/constants'
import { validateIdByFormat } from '../../../utils/participantValidation'

const SubjectIdInput = ({
  inputKey,
  label,
  type,
  placeholder,
  setSubjectId,
  fieldDisabled,
  updateField,
  isSubjectIdAvailable,
  resetSubjectIdStatus,
  value,
  showOnChange, // ✅ Added prop
  format,
  studyId,
  siteId,
  existingIds = [], // Subject IDs from existing participants for INCR auto-increment
}) => {
  // Check if format has {STUDY_ID}, {SITE_ID}, or constants (literal text like "123", "-234")
  const hasStudyId = format?.includes('{STUDY_ID}')
  const hasSiteId = format?.includes('{SITE_ID}')
  // Detect constants by removing all tokens and separators (-, spaces)
  // Only consider it a constant if there's actual text/numbers beyond just separators
  const textWithoutTokens = format ? format.replace(/\{[^}]+\}/g, '') : ''
  const hasConstants = textWithoutTokens.replace(/[-\s]/g, '').length > 0
  const shouldUsePatternInput = format && (hasStudyId || hasSiteId || hasConstants)

  return (
    <>
      {showOnChange && (
        <div className={`flexed end-aligned start-justified ${inputKey}-input-wrapper`}>
          {shouldUsePatternInput ? (
            <PatternInput
              disabled={fieldDisabled}
              label={label}
              pattern={format}
              constants={{ STUDY_ID: studyId, SITE_ID: siteId }}
              value={value}
              existingIds={existingIds}
              onIdChange={val => {
                setSubjectId(val)
                if (!val) resetSubjectIdStatus()
                updateField(inputKey, val)
              }}
            />
          ) : (
            <Input
              disabled={fieldDisabled}
              label={label}
              type={type}
              onChange={(val) => {
                setSubjectId(val)
                if (!val) resetSubjectIdStatus()
                updateField(inputKey, val)
              }}
              value={value || ''}
              id={`participant-form-${inputKey}`}
              placeholder={placeholder}
            />
          )}

          {value && format && !validateIdByFormat(value, format, { STUDY_ID: studyId, SITE_ID: siteId }) && (
            <div className="status-info-text">
              <div className="status-info-box">
                <i className="fa fa-exclamation-circle" />
                <div className="status-info-text">
                  <div>{STRINGS.invalidIdFormat}</div>
                  <div>
                    {STRINGS.invalidIdFormatMessage.replace('{format}', placeholder)}
                  </div>
                </div>
              </div>
            </div>
          )}

          {value && isSubjectIdAvailable !== null && (
            <div className={`${inputKey}-status ${!isSubjectIdAvailable ? 'no-margin-bottom' : ''}`}>
              {isSubjectIdAvailable ? (
                <div className='status-info-box'>
                  <i className='fa fa-check' />
                  <div className='status-info-text'>{STRINGS.thisIdIsAvailable}</div>
                </div>
              ) : (
                <div className='status-info-box'>
                  <i className='fa fa-exclamation-circle' />
                  <div className='status-info-text'>
                    <div>{STRINGS.thisIdIsTaken}</div>
                    <div>{STRINGS.pleaseChooseAnother}</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )} {/* ✅ Hide the entire input box */}
    </>
  )
}

SubjectIdInput.propTypes = {
  updateField: PropTypes.func,
  inputKey: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  setSubjectId: PropTypes.func,
  fieldDisabled: PropTypes.bool,
  isCreate: PropTypes.bool,
  isSubjectIdAvailable: PropTypes.bool,
  resetSubjectIdStatus: PropTypes.func,
  value: PropTypes.string,
  showOnChange: PropTypes.bool, // ✅ Added prop type
  format: PropTypes.string,
}

export default SubjectIdInput
